import { useState } from 'react'
import { Modal, Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'
import * as fromActions from 'store/actions/courses.action'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'
import TextAreaInput from 'components/ui/forms/field/text-area/TextArea'
import createRequest from 'api/enrols/createRequest'
import styles from './ModalEnrol.module.scss'

interface ICourseProps {
  courseId: number
  onAccept: () => void
  onClose: () => void
}

const ModalEnrol = ({ courseId, onAccept, onClose }: ICourseProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const prefix = 'courses.show.content'
  const [loading, setLoading] = useState(false)
  const [noteField, setNoteField] = useState('')

  const handleSave = async () => {
    setLoading(true)
    try {
      await createRequest({
        note: noteField,
        courseId: Number(courseId),
      })
      dispatch(fromActions.Actions.getCourse(+courseId))
      onAccept()
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (event: any) => setNoteField(event.target.value)
  const minLengthMsg = 10

  return (
    <Modal
      show={true}
      size="lg"
      onHide={onClose}
      centered
      className={styles.modalContainer}
    >
      <Modal.Header translate="yes" closeButton className="p-0 pb-2">
        <Modal.Title className={styles.title}>
          {t(`${prefix}.modal.title`)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0 pt-2">
        <Form>
          <Form.Group className={styles.formGroup}>
            <Form.Label className={styles.legend}>
              {t(`${prefix}.modal.legend`)}
            </Form.Label>
            <TextAreaInput
              name={'note'}
              className={`${styles.textbox} pb-0`}
              placeholder={t(`${prefix}.modal.placeholder`)}
              rows={5}
              label={''}
              value={noteField}
              onChange={handleChange}
              error={''}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size={ButtonSizes.Small}
          variant={ButtonVariant.Secondary}
          onClick={onClose}
        >
          {t('commons.buttons.cancel')}
        </Button>
        <Button
          size={ButtonSizes.Small}
          onClick={handleSave}
          disabled={noteField.length < minLengthMsg || loading}
        >
          {noteField.length < minLengthMsg
            ? `(${minLengthMsg - noteField.length})`
            : ''}{' '}
          {t('commons.buttons.accept')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalEnrol
